import { render, staticRenderFns } from "./Tieto.vue?vue&type=template&id=7a87feaa&"
import script from "./Tieto.vue?vue&type=script&lang=js&"
export * from "./Tieto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports